import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAccount, IAddress, IEmail, AccountRegister } from '../../../models/account';
import { MustMatch } from './mustMatch';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { AuthService } from '../../../shared/services/authentication/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {
  
  public accountForm: FormGroup;
  public passwordForm: FormGroup;
  public addressForm: FormGroup;
  public registerForm: FormGroup;
  
  public active = 1;
  public NavItemDisabled2: boolean = true;
  public NavItemDisabled3: boolean = true;
  public NavItemDisabled4: boolean = true;
  isLoginFailed = false;
  countryData: any;
  flag: any;
  errorMessage = '';

  public accountRegister = new AccountRegister();
  public finalAccount: IAccount = <IAccount>{};
  public finalEmail: IEmail = <IEmail>{};
  public finalAddress: IAddress = <IAddress>{};

  constructor(private route: Router, 
              public fb: FormBuilder, 
              private sharedServices: SharedService, 
              private authService: AuthService, 
              private toastrService: ToastrService,) {
    this.createAccountForm();
    this.createPasswordForm();
    this.createAddressForm();
    this.createRegisterForm();
  }

  //create Account form
  createAccountForm() {
      this.accountForm = this.fb.group({
        userName: [null, [Validators.required, Validators.pattern(/^[A-z0-9]*$/),]],
        firstName: [null, [Validators.required, Validators.pattern(/^[A-z]*$/),]],
        lastName: [null, [Validators.required, Validators.pattern(/^[A-z]*$/),]],
        emailAdd: ['', Validators.required]
      });
  }
    
  //create Password form
  createPasswordForm(){
      this.passwordForm = this.fb.group({      
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required]
      }, {
          validator: MustMatch('password', 'confirmPassword')
        });
  }

  //create Address form
  createAddressForm() {
      this.addressForm = this.fb.group({
        cityName: ['', Validators.required],
        zip: [null, Validators.required],
        country: [null, Validators.required],
        street: [null, Validators.required],
      });
  }

  //create Register form
  createRegisterForm() {
    this.registerForm = this.fb.group({
      about: ['', [Validators.required]],
      policy: [false, [Validators.required]]
    });
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
      .subscribe(
       data => {
         this.countryData = data.data.countries;
       },
       error => {
         console.log(error);
       });
  }

  setFlag(event){
      this.flag = this.countryData[this.addressForm.value['country']-1].alpha2Code;
  }

  // nawigacja następna po TAB dla Button
  onClickNext(){
    // musi być taka kolejność
    if(this.active==3){

      if(this.NavItemDisabled4){
        this.NavItemDisabled4=false;
      }
      this.active=4;
    }
    
    if(this.active==2){

      if(this.NavItemDisabled3){
        this.NavItemDisabled3=false;
      }
      this.active=3;
    }

    if(this.active==1){
      if(this.NavItemDisabled2){
        this.NavItemDisabled2=false;
      }
      this.active=2;
    }
  }

  // nawigacja wsteczna po TAB dla Button
  onClickPrevious(){
    // musi być taka kolejność
    if(this.active==2){
      this.active=1;
    }
    
    if(this.active==3){
      this.active=2;
    }
    
    if(this.active==4){
      this.active=3;
    } 

  }

    // wysłanie utworzenie nowego Publishera dla Button
    onRequest() {
      // send API date to backend
      // redirect to login
      this.accountRegister.username = this.accountForm.value['userName'];
      this.accountRegister.firstName = this.accountForm.value['firstName'];
      this.accountRegister.lastName = this.accountForm.value['lastName'];
      this.accountRegister.email = this.accountForm.value['emailAdd'];
      this.accountRegister.password = this.passwordForm.value['password'];
      this.accountRegister.countryId = this.addressForm.value['country'];
      this.accountRegister.city = this.addressForm.value['cityName'];
      this.accountRegister.zipCode = this.addressForm.value['zip'];
      this.accountRegister.address = this.addressForm.value['street'];
      this.accountRegister.about = this.registerForm.value['about'];
  
      this.authService.register(this.accountRegister).subscribe(
        response => {
          this.isLoginFailed = false;
          this.toastrService.success('You are registered now ! Please wait for the account verifivation and contact from us.', 'Success !');
          this.route.navigate(['/']);
      },
      err => {
        console.log(err);
        this.errorMessage = err.error.errors[0].message;
        this.isLoginFailed = true;
        this.toastrService.error(`${this.errorMessage}`, 'Error !');
      });
    }

  ngOnInit() {
    this.getCountries();
   }

}
